module.exports = __webpack_public_path__ + "img/Yenka.1828944a.png";